<template>
    <div class="acomodar"> 
        <GestionCese/>
    </div>
</template>

<script>
import GestionCese from '@/components/ModContratos/GesCese/GesCese.vue'
export default {
    name: 'SolimanologGestionDeCese',
    components:{
        GestionCese
    },
    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    created(){
    this.cambiarEstadoNavbar()

    },

    methods: {
        cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    }, 
    },
};
</script>
